(function () {
  'use strict';

  function restartAnimation(el) {
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
  }

  function init(root) {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    if (slides.length === 0) return;

    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const interval = Math.max(2000, parseInt(root.dataset.interval, 10) || 5000);
    const autoplayEnabled = root.dataset.autoplay !== 'false' && slides.length > 1;

    let current = 0;
    let timer = null;
    let onScreen = true;

    root.style.setProperty('--slideshow-interval', interval + 'ms');
    root.style.setProperty('--slideshow-count', String(slides.length));

    function setActive(index) {
      const len = slides.length;
      const normalized = ((index % len) + len) % len;

      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === normalized));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === normalized));

      const active = slides[normalized];
      active.querySelectorAll('.slideshow__img').forEach(restartAnimation);
      const activeDot = dots[normalized];
      if (activeDot) restartAnimation(activeDot.querySelector('.slideshow__dot-progress'));

      current = normalized;
    }

    function start() {
      stop();
      if (!autoplayEnabled || !onScreen) return;
      timer = setInterval(() => setActive(current + 1), interval);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (slides.length > 1) {
      if (prev) prev.addEventListener('click', () => { setActive(current - 1); start(); });
      if (next) next.addEventListener('click', () => { setActive(current + 1); start(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { setActive(i); start(); }));

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else start();
      });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            onScreen = entry.isIntersecting;
            if (onScreen) start();
            else stop();
          });
        }, { threshold: 0.1 });
        io.observe(root);
      }
    }

    setActive(0);
    start();
  }

  function bootstrap() {
    document.querySelectorAll('[data-slideshow]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
